<template>
   <!-- LOADER -->
   <!--<div v-if="loadingScreen" class="loader-screen">
      <div class="text-center">
         <div class="spinner-border text-primary loader-spinner"></div>
         <div class="loader-text mt-3">{{ loadingText }}</div>
      </div>
   </div>-->

   <div class="container">
   <!--<div v-show="!loading" class="container">-->
      <div class="row justify-content-center">
         <div class="col-md-5 col-lg-4 my-5">
            <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
               <div class="card-body bg-sa-card-body p-2">

                <!--Addition-->
                <!--<h1 v-if="loggingIn">
               <span>{{progressMessage}}</span> <img :src="`img/progress.gif`" height="15" />
            </h1>-->
            
<!-- Heading and alert share one fixed-height slot, so nothing jumps -->
<div class="signup-status">
    <div
        v-if="showAlert"
        :class="['alert', `alert-${alertType}`, 'd-flex', 'align-items-center', 'w-100', 'mb-0']"
        role="alert"
    >
        <span class="flex-grow-1">{{ alertMessage }}</span>
        <button
            type="button"
            class="btn-close ms-auto"
            @click="showAlert = false"
            aria-label="Close"
        ></button>
    </div>

    <h3 v-else class="card-title text-center w-100 mb-0">
        <template v-if="!loggingIn">Login</template>
        <template v-else>
            Logging in
            <img src="img/progress.gif" height="15" class="ms-2" alt="Loading" />
        </template>
    </h3>
</div>            


                  <form id="loginForm" @submit.prevent="submitRecord()" novalidate autocomplete="off">
                     <!-- Fake hidden fields to prevent autofill -->
                     <input type="text" name="fakeusername" style="display:none">
                     <input type="password" name="fakepassword" style="display:none">
                     <div class="mb-0">
                        <label for="email" class="form-label">Email address</label>
                        <div class="input-group">
                           <span class="input-group-text d-md-flex"><i class="fa fa-envelope"></i></span>
                           <input v-model="email" @input="handleInputChange" @change="handleInputChange" type="email" class="form-control custom-tooltip-input" id="email" placeholder="Enter email"   required autocomplete="new-email">
                           <div class="custom-tooltip">Please enter your Email <span class="tooltip-arrow"></span></div>
                        </div>
                     </div>
                     <div class="mb-0">
                         <label for="password" class="form-label">Password</label>
                         <div class="input-group">
                            <span class="input-group-text d-md-flex"><i class="fa fa-lg fa-lock"></i></span>
                            <input
                               v-model="password"
                               @input="handleInputChange"
                               @change="handleInputChange"
                               :type="showPassword ? 'text' : 'password'"
                               class="form-control custom-tooltip-input"
                               id="password"
                               name="pass_12345"
                               placeholder="Password"
                               required
                               autocomplete="new-password"
                            >
                            <div class="custom-tooltip">Please enter your Password <span class="tooltip-arrow"></span></div>
                         </div>
                     </div>
                     
                     <div class="d-grid mb-0 mt-2">

                      <div class="form-check mt-2">
    <input
        v-model="showPassword"
        class="form-check-input"
        type="checkbox"
        id="showPassword"
    />
    <label class="form-check-label" for="showPassword">Show password</label>
</div>

<div class="form-check mt-2">
    <input
        v-model="rememberMe"
        class="form-check-input"
        type="checkbox"
        id="rememberMe"
    />
    <label class="form-check-label" for="rememberMe">Remember my email?</label>
</div>


                        <button
   type="submit"
   class="btn btn-primary"
   :disabled="loggingIn"
>
   <template v-if="!loggingIn">
      <i class="bi bi-box-arrow-in-right me-2"></i>
      Login
   </template>

   <template v-else>
      <span>{{ progressMessage }}</span>
      <img
         src="img/progress.gif"
         height="15"
         class="ms-2"
         alt="Loading"
      />
   </template>
</button>
                     </div>
                     <div class="text-center mb-3">
                        <span class="sa-core-color">OR</span>
                     </div>
                     <!--<div class="d-flex gap-2">
                        <button type="button" class="btn btn-outline-danger flex-fill">
                        <i class="bi bi-google"></i> Google
                        </button>
                        <button type="button" class="btn btn-outline-primary flex-fill">
                        <i class="bi bi-facebook"></i> Facebook
                        </button>
                     </div>-->
                  </form>
                    <!-- Shown only after an unverified login -->
                    <div v-if="unverifiedEmail" class="d-grid mt-2">
                        <button type="button" class="btn btn-warning fw-semibold text-dark"
                                :disabled="sendingVerification || resendCooldown > 0"
                                @click="sendVerificationEmail(unverifiedEmail)">
                            <i v-if="sendingVerification" class="fa fa-cog fa-spin me-1"></i>
                            <i v-else class="fa fa-envelope me-1"></i>
                            {{ resendLabel }}
                        </button>
                    </div>
                    <div class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                        <!--Don't have an account?-->                         
                        <router-link to="/register/">
                          <a href="#" class="text-decoration-none btn btn-primary d-grid mb-0">Sign up</a>
                        </router-link>
                     </div>
                     <div class="d-flex justify-content-center mb-1">                        
                      <router-link to="/forgot-password/">
                         <a href="#" class="text-decoration-none small">Forgot Password? Click here</a>
                      </router-link>
                      
                     </div>
                     <!--<p>
                       <router-link to="/mfa-send-code/">
                          <a href="#" class="text-decoration-none">mfa-send-code</a>
                        </router-link>
                     </p>
                     <p>
                       <router-link to="/mfa-verify-code/">
                          <a href="#" class="text-decoration-none">mfa-verify-code</a>
                        </router-link>
                     </p>-->
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import { ref, onMounted } from 'vue'
   import { computed } from 'vue';
   import axios from 'axios';
   import emitter from '../../../main.js';
   import { mapMutations } from 'vuex';
   import { mapActions } from 'vuex';

   //const loading = ref(true)
   const email = ref('')
   const password = ref('')

   //const loadingScreen = ref(true)
   //const loadingText = ref('Preparing')

   /*const messages22 = [
     'Preparing the app...',
     'Configuring your experience...'
     //'Loading your dashboard...',
     //'Almost ready, please wait...',
     //'Finalizing setup...',
     //'Just a moment, we’re almost there...'
   ];*/
   //var Emitter = require('tiny-emitter');
   //var emitter = new Emitter();
   
    export default {
      components: {
      },
      data(){
        return {
            //loading: true,
            //loadingScreen: true,
            //loadingText: 'Preparing',
            /*messages: [
              'Preparing the app...',
              'Configuring your experience...'
            ],*/
            email: "", 
            password: "", 
            showPassword: false,
            name: '', 
            user_id: '', 
            loggingIn: false,
            rememberMe: false,
            showAlert: false,
            alertType: '', // 'success' or 'danger'
            alertMessage: '',
            progressMessage: 'Please wait',
            button_text: '',
            unverifiedEmail: '',
            sendingVerification: false,
            resendCooldown: 0,      // seconds left before Resend works
            resendTimer: null,
        }
      },
      beforeUnmount() {
        clearInterval(this.resendTimer);
      },
      computed: {
        resendLabel() {
            if (this.sendingVerification) return 'Sending...';
            if (this.resendCooldown > 0) {
                const s = String(this.resendCooldown % 60).padStart(2, '0');
                return `Resend verification email in ${Math.floor(this.resendCooldown / 60)}:${s}`;
            }
            return 'Resend verification email';
        },
      },
      created() {        
        // Pre-fill the email if the user asked to be remembered last time.
        const savedEmail = localStorage.getItem('remembered_email');
        if (savedEmail) {
            this.email = savedEmail;
            this.rememberMe = true;
        }

            this.handleEmailVerificationMessage();    
            this.showSuccessBackendMessage();            
      },
      mounted(){
        /*let i = 0

  const interval = setInterval(() => {
    i++
    if (i < this.messages.length) {
      this.loadingText = this.messages[i]
    } else {
      clearInterval(interval)
      this.loading = false
      this.loadingScreen = false
    }
  }, 900)*/
      },
      methods: {
            ...mapMutations(['setUserDetails','SET_PERMISSIONS']),
            ...mapActions(['retriveUserDetails']),
        submitRecord(){
          // Ignore Enter or clicks while a login is already running.
          if (this.loggingIn) return;
          if (!this.handleBeforeSend()) { return;}
               //return;

          // Remember the email only if the box is ticked; otherwise forget it.
          if (this.rememberMe) {
              localStorage.setItem('remembered_email', this.email);
          } else {
              localStorage.removeItem('remembered_email');
          }
          const formData = new FormData();
               const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          formData.append('email', this.email);
          formData.append('password', this.password);
               formData.append('timezone', timezone);
          formData.append('action', 'login'); 
          axios.post('/auth/api_auth.php', formData,{withCredentials: true})
               .then(response=>{  

            if (response.data.status === 'success') {                
                this.handleSuccess(response);   
            } else if (response.data.status === 'mfaSendCode') {
                this.handleMfaSendCode(response);
            } else if (response.data.status === 'unverified') {
                this.handleUnverifiedEmail(response);
            } else {
                this.handleError(response.data.message);
            }

          })
          .catch(error=>{            
                  this.handleError(error);
          })
        },    
            handleBeforeSend(){
               //const formIsValid = formValidations('#loginForm'); 
               const formIsValid = this.$validateForm('#loginForm');
                   if (!formIsValid) {
                        return; // Prevent form submission if validation fails
                    }
               this.loggingIn=true;
               this.showAlert = false;
               this.showPassword = false;
               return true;
            },
            // This method handles the response when the verification is successful
            handleSuccess(response) {
               if (response.data.results.is_locationRequired===1) {
                           this.$checkLocationPermission(this, this.$router, this.$route)
                                .then(() => {                                 
                              if (this.$store.state.latitude===null) {
                                 this.loggingIn=false;
                                    return;
                              } else {            
                                 this.processData(response);
                              }
                           });                                                     
                        } else {
                              this.processData(response);
                        } 
            },
            handleUnverifiedEmail(response) {
                this.alertType = 'warning';
                this.alertMessage = response.data.message;
                this.showAlert = true;
                this.loggingIn = false;

                // Send verification email separately (the server limits how often)
                this.unverifiedEmail = response.data.results.email;
                if (this.resendCooldown === 0) {
                    this.sendVerificationEmail(this.unverifiedEmail);
                }
            },
            handleMfaSendCode(response){
               // sessionStorage: cleared when the tab closes
               sessionStorage.setItem('mfa_token', response.data.mfa_token);
               sessionStorage.setItem('mfa_phone', response.data.phone_masked || '');
               sessionStorage.setItem('mfa_email', response.data.email_masked || '');
               this.loggingIn = false;
               this.$router.push('/mfa-send-code/');
            },
            handleError(error) {
               this.alertType = 'danger';

               if (typeof error === 'string') {
                  this.alertMessage = error;
               } else if (error && error.data && error.data.message) {
                  this.alertMessage = error.data.message;
               } else if (error && error.message) {
                  this.alertMessage = error.message;
               } else {
                  //this.alertMessage = 'An unexpected error occurred.';
                  this.alertMessage = 'Connection issue. Contact the admin.';
               }
               
               this.showAlert = true;
               this.loggingIn = false;
               this.$router.push('/');
            },
            /*
            handleError(error) { 
               this.alertType = 'danger';
               if (error && error.data && error.data.message) {
                  this.alertMessage = error.data.message;
               } else {
                  //this.alertMessage = 'An unexpected error occurred.';
                  this.alertMessage = error;
               }
               this.showAlert = true;
               this.loggingIn = false;
               this.$router.push('/');
            },*/
            processData(response){
                  //Begin populating
                        
                              localStorage.removeItem('mfa_email');                     
                           this.loggingIn=false;
                  localStorage.setItem('jwt', response.data.results.token);                  
                  localStorage.setItem('csrf_token', response.data.results.csrf_token);
                  localStorage.setItem('is_locationRequired', response.data.results.is_locationRequired);
                  localStorage.setItem('roles', JSON.stringify(response.data.results.roles));localStorage.setItem('permissions', JSON.stringify(response.data.results.permissions));                 
                  this.SET_PERMISSIONS(response.data.results.permissions);

                  localStorage.setItem('subscription', JSON.stringify(response.data.results.subscription));
                  localStorage.setItem('subscription_permissions', JSON.stringify(response.data.results.subscription_permissions));  
                  localStorage.setItem('first_name', response.data.results.first_name);localStorage.setItem('user_pic', response.data.results.user_pic);
                  localStorage.setItem('company_id', response.data.results.company_id);
                  localStorage.setItem('company_currency', response.data.results.company_currency || 'KES'); // money boxes: KES / USD
                  localStorage.setItem('branch_id', response.data.results.branch_id);
                  localStorage.setItem('branch_name', response.data.results.branch_name);
                  localStorage.setItem('loggedIn', true);


                           //store.js also sets below data (repetion but better)
                           const userData = {
                             user: {
                               /*user_id: '123',
                               company_id: '456',*/
                               company_id: response.data.results.company_id,
                               company_name: response.data.results.company_name,
                               branch_id: response.data.results.branch_id,
                               branch_name: response.data.results.branch_name,
                               first_name: response.data.results.first_name,
                               user_pic: response.data.results.user_pic,
                               tokenExpirationTime: '2025-04-11T12:00:00Z'
                             },
                             token: response.data.results.token
                           };

                           // Commit to Vuex store
                           this.setUserDetails(userData);

                           //$('#navibar').show();
                             emitter.emit('OnLogin', true)
                           /*end hey*/
                           
                              if (this.verifyJWT()) {
                                 this.$router.push('/dashboard/');
                              }
                        //End populating       
                  

            },
            showSuccessBackendMessage(){
               //const message = sessionStorage.getItem('backend_message');
               const backend_message = sessionStorage.getItem('backend_message');
               const backend_alertType = sessionStorage.getItem('backend_alertType');
               if (backend_message && backend_alertType) {
                  console.log("backend_message is:" + backend_message);
                  console.log("backend_alertType is:" + backend_alertType);
                  this.alertMessage = backend_message;
                  this.alertType = backend_alertType;
                  this.showAlert = true;
                  
                  //clear after use first then call showSuccessBackendMessage
                  sessionStorage.removeItem('backend_message');
                  sessionStorage.removeItem('backend_alertType');
                  //$('.alert-success').show().fadeOut(10000);
                  //$('.alert-success').html(message);
               }
            },
            handleInputChange(event) {
         // Call the validation function for the specific input field that triggered the event
         //formValidations(event.target);
         this.$validateField(event.target);
       },
        verifyJWT(){
               console.log("Router instance:", this.$router); // Check if it's defined
          return this.$store.dispatch('retriveUserDetails', this.$router);// if you dont want to use map actions
               //this.retriveUserDetails(this.$router);
        },
                // Same wait as the server ($resendAfterSeconds in handleEmailVerification)
        startResendCooldown(seconds = 60) {
            clearInterval(this.resendTimer);
            this.resendCooldown = seconds;
            this.resendTimer = setInterval(() => {
                this.resendCooldown--;
                if (this.resendCooldown <= 0) {
                    clearInterval(this.resendTimer);
                }
            }, 1000);
        },
        sendVerificationEmail(email) {
            if (!email || this.sendingVerification || this.resendCooldown > 0) return;
            this.sendingVerification = true;

            const formData = new FormData();
            formData.append('email', email);
            formData.append('action', 'sendVerificationEmail');

            axios.post('/auth/api_auth.php', formData, { withCredentials: true })
                .then(response => {
                    this.alertType = response.data.status === 'success' ? 'warning' : 'danger';
                    this.alertMessage = response.data.message;
                    this.showAlert = true;
                    if (response.data.status === 'success') {
                        this.startResendCooldown(60);
                    }
                })
                .catch(error => {
                    console.error('Verification email request failed:', error);
                })
                .finally(() => {
                    this.sendingVerification = false;
                });
        },
        handleEmailVerificationMessage() {
    const params = new URLSearchParams(window.location.search);
    const verification = params.get('verification');

    if (!verification) {
        return;
    }

    if (verification === 'success') {
        sessionStorage.setItem(
            'backend_message',
            'Your email has successfully been verified! Please login.'
        );

        sessionStorage.setItem(
            'backend_alertType',
            'success'
        );
    }

    else if (verification === 'failed') {
        sessionStorage.setItem(
            'backend_message',
            'Email verification failed! Please login again to resend verification link.'
        );

        sessionStorage.setItem(
            'backend_alertType',
            'danger'
        );
    }

    else if (verification === 'expired') {
        sessionStorage.setItem(
            'backend_message',
            'Your email verification link has expired. Please login again to resend verification link.'
        );

        sessionStorage.setItem(
            'backend_alertType',
            'danger'
        );
    }

    else if (verification === 'invalid') {
        sessionStorage.setItem(
            'backend_message',
            'Incorrect verification link. Please login again to resend verification link.'
        );

        sessionStorage.setItem(
            'backend_alertType',
            'danger'
        );
    }

    // Remove verification query parameter from browser URL
    // Remove verification query parameter from browser URL
window.history.replaceState(
    {},
    document.title,
    window.location.pathname + window.location.hash
);
    
},
        //End handleEmailVerificationMessage



      }
    };
</script>
